'use strict';

var jsxRuntime = require('react/jsx-runtime');
var icons_Icon = require('./Icon.js');
require('react');
require('../_chunks/combineClasses-5P8GTQkg.js');
require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');

const IconArrow = icons_Icon.iconFactory('IconArrow', jsxRuntime.jsx("path", { "data-icon-type": "fill", fillRule: "evenodd", clipRule: "evenodd", d: "M5.25 11.1889L7.39173 13.3102L10.5032 10.2285L10.5032 19.5032L13.5032 19.5032L13.5032 10.2348L16.6083 13.3102L18.75 11.1889L12 4.5032L5.25 11.1889Z" }));

exports.IconArrow = IconArrow;
//# sourceMappingURL=IconArrow.js.map
